// Dependencies
import styled from "styled-components";

// Utils
import { theme } from "config/theme";

export const Container = styled.div`
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: center;

    padding: 48px;
    border-radius: 8px;
    background-color: ${theme.colors.base[100]};
`;

export const ContentLabel = styled.p`
    font-family: "Nunito Sans", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    color: ${theme.colors.base[500]};
`;
